import type { FunctionComponent } from "react"

import { Heading } from "@jobteaser/spark/components/Heading"
import { Layout, LAYOUT_COLOR_BLOCK } from "@jobteaser/ui-kit/dist/module/components/Layout/Layout"

import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./TeamsTitle.module.css"

export const TeamsTitle: FunctionComponent = () => {
  const { t } = useTranslation(["companies_client"])

  return (
    <Layout colorBlock={LAYOUT_COLOR_BLOCK.WHITE}>
      <Layout.Column>
        <Heading as="h2" variant="title2" weight="bold" className={styles.main}>
          {t("companies_client.teams.presentation.title")}
        </Heading>
      </Layout.Column>
    </Layout>
  )
}
